import React from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Building2, Mail, MapPin, FileText } from 'lucide-react';
import SEOHead from '../components/SEOHead';

const Impressum = () => {
  const location = useLocation();
  const currentLang = location.pathname.startsWith('/de') ? 'de' : 'en';

  const seoContent = {
    en: {
      title: 'Impressum | Legal Information | Podcast Zurich',
      description: 'Legal information and company details for Podcast Zurich. Podcast Zurich GmbH, CHE-439.127.972, Werdstrasse 36, 8004 Zürich, Switzerland.',
    },
    de: {
      title: 'Impressum | Rechtliche Informationen | Podcast Zürich',
      description: 'Rechtliche Informationen und Unternehmensdaten für Podcast Zürich. Podcast Zurich GmbH, CHE-439.127.972, Werdstrasse 36, 8004 Zürich, Schweiz.',
    }
  };

  const content = {
    en: {
      title: 'Impressum',
      subtitle: 'Legal Information',
      company: 'Company',
      vatId: 'VAT ID',
      address: 'Address',
      contact: 'Contact',
    },
    de: {
      title: 'Impressum',
      subtitle: 'Rechtliche Informationen',
      company: 'Unternehmen',
      vatId: 'MwSt-Nr.',
      address: 'Adresse',
      contact: 'Kontakt',
    },
  };

  const t = content[currentLang];

  return (
    <>
      <SEOHead 
        title={seoContent[currentLang].title}
        description={seoContent[currentLang].description}
        canonicalPath={`/${currentLang}/impressum`}
        ogImage="https://customer-assets.emergentagent.com/job_podcast-hub-22/artifacts/re8fiacy_DSC05748.jpg"
      />
      <main className="min-h-screen pt-24 pb-16" role="main">
        {/* Hero Section */}
        <section className="py-16 px-6 bg-gradient-to-br from-gray-100 to-gray-200" aria-labelledby="impressum-heading">
          <div className="max-w-4xl mx-auto text-center">
            <h1 id="impressum-heading" className="text-5xl md:text-6xl font-bold mb-4 text-gray-900">
            {t.title}
          </h1>
          <p className="text-xl text-gray-700">
            {t.subtitle}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 px-6">
        <div className="max-w-2xl mx-auto">
          <Card className="border-2">
            <CardContent className="p-8 space-y-8">
              {/* Company */}
              <div className="flex items-start gap-4">
                <Building2 className="w-6 h-6 text-gray-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">{t.company}</h3>
                  <p className="text-lg text-gray-900">Collocio GmbH</p>
                </div>
              </div>

              {/* VAT ID */}
              <div className="flex items-start gap-4">
                <FileText className="w-6 h-6 text-gray-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">{t.vatId}</h3>
                  <p className="text-lg text-gray-900">CHE-332.061.094 MWST</p>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-gray-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">{t.address}</h3>
                  <p className="text-lg text-gray-900">
                    Riedtlistrasse 4<br />
                    8006 Zürich<br />
                    Switzerland
                  </p>
                </div>
              </div>

              {/* Contact */}
              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-gray-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-700 mb-1">{t.contact}</h3>
                  <a 
                    href="mailto:info@podcastzurich.com" 
                    className="text-lg text-gray-900 hover:underline"
                  >
                    info@podcastzurich.com
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
      </main>
    </>
  );
};

export default Impressum;
